document.addEventListener("DOMContentLoaded", function () {
  const triggerBtn = document.getElementById("cart-drawer-button-section");

  if (triggerBtn) {
    triggerBtn.addEventListener("click", function () {
      // Try to find the "real" open button inside the cart drawer component
      const cartDrawer = document.querySelector("cart-drawer-component");

      if (!cartDrawer) return;

      const openButton = cartDrawer.querySelector('button[on\\:click="/open"]');

      if (openButton) {
        openButton.click();
      } else {
        console.warn("Cart drawer open button not found");
      }
    });
  }

  function updateCallOuts() {
    const lastVariantAdded = window.localStorage.getItem("lastVariantAdded");
    const cartItemCallOut = document.querySelector(
      `[data-call-out="${lastVariantAdded}"]`
    );
    if (cartItemCallOut) cartItemCallOut.classList.remove("hidden");
  }
  document.addEventListener("cart:update", () => {
    updateCallOuts();
  });

  updateCallOuts();
  // Custom trigger for Sizefox button click to trigger the app's size chart button
  const APP_SELECTOR = '.smartsize-button__label';
  const CUSTOM_SELECTOR = '#trigger-sizefox-custom';

  function handleCustomClick(e) {
    e.preventDefault();
    const appButton = document.querySelector(APP_SELECTOR);
    if (appButton) {
      appButton.click();
    }
  }

  document.body.addEventListener('click', function(e) {
    if (e.target.matches(CUSTOM_SELECTOR) || e.target.closest(CUSTOM_SELECTOR)) {
      handleCustomClick(e);
    }
  });

  const domObserver = new MutationObserver(() => {
    const appButton = document.querySelector(APP_SELECTOR);
    const customBtn = document.querySelector(CUSTOM_SELECTOR);

    if (!customBtn) return;

    if (appButton) {
      customBtn.style.setProperty('display', 'block', 'important');
    } else {
      customBtn.style.setProperty('display', 'none', 'important');
    }
  });

  domObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  const appButton = document.querySelector(APP_SELECTOR);
  const customBtn = document.querySelector(CUSTOM_SELECTOR);
  if (appButton && customBtn) {
    customBtn.style.setProperty('display', 'block', 'important');
  }
});


document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 768) return;

  const accordions = document.querySelectorAll(
    'accordion-custom[data-is-footer-accordion="true"] details'
  );

  accordions.forEach((details) => {
    details.setAttribute('open', '');

    details.addEventListener('toggle', () => {
      details.setAttribute('open', '');
    });

    const summary = details.querySelector('summary');

    if (summary) {
      summary.style.pointerEvents = 'none';
      summary.style.cursor = 'default';
    }
  });
});